import { Icon } from "leaflet";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import { useSelector } from "react-redux";
import { selectSpots } from "../spotsSlice";
import SpotCard from "./SpotCard";

export const SpotMap = () => {
  const position = [43.6667, -1.4167]; // Coordonnées de Hossegor, France pour centrer la carte

  const surfIcon = new Icon({
    iconUrl: "/spot.png",
    iconSize: [38, 38],
  });

  const spots = useSelector(selectSpots);

  return (
    <MapContainer
      center={position}
      zoom={3}
      style={{ height: "50vh", width: "100%" }}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

      <MarkerClusterGroup chunkedLoading>
        {spots.map((spot) => {
          return (
            <Marker
              position={[spot.latitude, spot.longitude]}
              icon={surfIcon}
              key={spot.id}
            >
              <Popup>
                <div style={{ width: "230px" }}>
                  <SpotCard id={spot.id} />
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MarkerClusterGroup>
    </MapContainer>
  );
};
